<script>
    import SessionSelectorPanel from './index';
    import _ from 'lodash';

    export default {
        name: '',
        extends: SessionSelectorPanel,
        created () {
            this.loadEnteredCompetitions();
        },
        computed: {
            competitions () {
                return this.$store.state.competition.enteredCompetitions;
            },
            currentCompetitionId () {
                return this.$store.state.competition.currentEnteredCompetitionId;
            }
        },
        watch: {
            competitions: {
                immediate: true,
                handler (competitions) {
                    if (competitions !== null && competitions.length > 0) {
                        this.$store.commit('competition/updateCurrentEnteredCompetitionId', _.get(competitions[0], 'id'));
                        this.$store.commit('competition/updateCurrentEnteredCompetitionName', _.get(competitions[0], 'name'));
                    }
                }
            }
        },
        methods: {
            loadEnteredCompetitions () {
                this.$store.dispatch('competition/loadPersonalEnteredCompetitions').then();
            },
            changeCompetition (id, name) {
                this.$store.commit('competition/updateCurrentEnteredCompetitionId', id);
                this.$store.commit('competition/updateCurrentEnteredCompetitionName', name);
            }
        }
    };
</script>
